$(document).ready(function(){
	
	var sliderBannersSettings = {
		autoplay: true,
		autoplaySpeed: 4000,
		infinite: true,
		pauseOnHover: true,
		speed: 800,
	};
  $('.slider--banners').slick(sliderBannersSettings);

	
	var sliderGallerySettings = {
		infinite: false,
		pauseOnHover: true,
		speed: 800,
	};
  $('.slider--gallery').slick(sliderGallerySettings);

	
	var sliderLaureatsSettings = {
		slidesToShow: 3,
		infinite: false,
		pauseOnHover: true,
		speed: 800,
		responsive: [
		  {
		    breakpoint: 1092,
		    settings: {
		      slidesToShow: 2,
		    }
		  },
		  {
		    breakpoint: 768,
		    settings: {
		      slidesToShow: 1,
		      arrows: false,
		      dots: true
		    }
		  }
		]
	};
  $('.slider--laureats').slick(sliderLaureatsSettings);

});